import {SearchType} from './types'
import {buildResultsSearch} from './resultsParams'

/**
 * Maps each SearchType to its dedicated results route. Placeholder pages are wired in
 * PrivateRoutes for the types whose full UX has not shipped yet.
 */
export const pathForType = (type: SearchType): string => {
  switch (type) {
    case 'members':
      return '/members-search'
    case 'experiences':
      return '/experiences-search'
    case 'forums':
      return '/forums-search'
    case 'mastermind_circles':
      return '/circles-search'
    case 'expertise':
      return '/expert-search'
    case 'all':
    default:
      return '/search'
  }
}

export const buildResultsUrl = (query: string, type: SearchType): string =>
  `${pathForType(type)}${buildResultsSearch(query, type)}`
